<template lang="pug">
div
    ListItem
        ListItemMeta(:title='$t("accountInfo.creditCard.titleText")') 
            template(slot="description")
                p(v-if="!userInfoData.cardId") {{ $t('accountInfo.creditCard.notSetDescriptionText') }}
                div(v-else)
                    div(style="display: flex; flex-direction: row; align-items: center")
                        Icon(type="md-card")
                        p {{creditCardData.number}}     
                    p {{ $t('accountInfo.creditCard.setDescriptionText') }} {{chargeDate}}
        li(slot="extra")
            Button.cardBtn(type="default" @click="removeCreditCard" v-if="userInfoData.cardId") {{ $t('accountInfo.creditCard.removeCreditCardBtnText') }}
            Button.cardBtn(type="primary" @click="addCreditCard" v-if="!userInfoData.cardId") {{ $t('accountInfo.creditCard.addCreditCardBtnText') }}
            Button.cardBtn(type="primary" @click="editCreditCard" v-else) {{ $t('accountInfo.creditCard.editCreditCardBtnText') }}

    Modal(v-model="isOpened" :title="modalTitle" @on-cancel="closeModalEvent" footer-hide width="600")
        Card(dis-hover)
            div(style="display: flex; flex-direction: row; align-items: center")
                Icon(type="md-card")
                p.cardTitle {{ $t('accountInfo.creditCard.editCreditCardBtnText') }}
            Form(style="width: 100%" ref="form" :model="creditCardInfo" :rules="validateRule")
                FormItem.formItem(prop="number" :label='$t("accountInfo.creditCard.card.title")')
                    Input(prefix="md-card" placeholder="Number" v-model="creditCardInfo.number" maxlength="19" @on-keypress="formatCardNumber(creditCardInfo.number)")
                div(style="display: flex; flex-direction: row; align-items: center; width: 100%")
                    FormItem.formItem(prop="date" :label='$t("accountInfo.creditCard.card.date")')
                        Input(prefix="md-card" placeholder="MM/YYYY" v-model="creditCardInfo.date" maxlength="7" @on-keypress="formatDate(creditCardInfo.date)")
                    FormItem.formItem(prop="cvc" :label='$t("accountInfo.creditCard.card.cvc")')
                        Input(prefix="md-card" placeholder="CVC" v-model="creditCardInfo.cvc" maxlength="4")
        .paymentModalFooter
            div
                p {{ $t('accountInfo.creditCard.descriptionText') }}
                p(v-if="isShowDescriptionTwoText") {{ $t('accountInfo.creditCard.descriptionTwoText') }}
            div(style="width: 180px;text-align: right;")
                Button.cardBtn(@click="closeModalEvent" ) {{ $t('accountInfo.cancelBtnText') }}
                Button.cardBtn(type="primary" @click="updateCard") {{ $t('accountInfo.saveBtnText') }}


</template>

<script>
import { _getCustomer, _createCustomer, _updateCustomer, _getCard, _createCard, _deleteCard } from "@/api/billing";

import { getEsData } from "@/api/esdata";

import moment from "moment";

export default {
    name: "CreditCardListItem",
    props: ["userInfoData"],
    data() {
        return {
            creditCardData: {
                number: "",
                exp_month: "",
                exp_year: "",
                cvc: "",
            },
            isOpened: false,
            validateRule: {
                number: [
                    {
                        validator: (rule, value, callback) => {
                            if (!/([0-9]{4}\s[0-9]{4}\s[0-9]{4}\s[0-9]{4})$/.test(value) || value.length > 19) {
                                // callback(new Error("請輸入正確卡號"));
                                callback(new Error(this.$t("accountInfo.creditCard.messageText.cardNumberText")));
                            }
                            callback();
                        },
                        trigger: "blur",
                        required: true,
                    },
                ],
                date: [
                    {
                        validator: (rule, value, callback) => {
                            const thisYear = new Date().getFullYear();
                            if (/^(0[1-9]|1[0-2])\/?([0-9]{4})$/.test(value)) {
                                if (value.split("/")[0] > 12 || value.split("/")[0] < 1) {
                                    callback(new Error(this.$t("accountInfo.creditCard.messageText.cardMMText")));
                                }
                                if (value.split("/")[1] < thisYear) {
                                    callback(new Error(this.$t("accountInfo.creditCard.messageText.cardYearText")));
                                }
                                callback();
                            } else {
                                if (value.split("/")[0] > 12 || value.split("/")[0] < 1) {
                                    callback(new Error(this.$t("accountInfo.creditCard.messageText.cardMMText")));
                                }
                                if (value.split("/")[1] < thisYear) {
                                    callback(new Error(this.$t("accountInfo.creditCard.messageText.cardYearText")));
                                }
                                callback(new Error(this.$t("accountInfo.creditCard.messageText.cardDateText")));
                            }
                        },
                        trigger: "blur",
                        required: true,
                    },
                ],
                cvc: [
                    {
                        validator: (rule, value, callback) => {
                            if (value.length > 4) {
                                callback(new Error(this.$t("accountInfo.creditCard.messageText.cardCVCText")));
                            }
                            callback();
                        },
                        trigger: "blur",
                        required: true,
                    },
                ],
            },
            creditCardInfo: {},
            actionType: "add",
            createdDate: "",
        };
    },
    methods: {
        closeModalEvent() {
            this.isOpened = false;
            this.creditCardInfo = {
                number: "",
                exp_month: "",
                exp_year: "",
                cvc: "",
            };
        },
        updateCard() {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return this.$Message.error(this.$t("accountInfo.creditCard.messageText.cardInfoText"));
                } else {
                    this.creditCardInfo.exp_month = this.creditCardInfo.date.split("/")[0];
                    this.creditCardInfo.exp_year = this.creditCardInfo.date.split("/")[1];
                    delete this.creditCardInfo.date;
                    this.updateCreditCardInfo();
                }
            });
        },
        async updateCreditCardInfo() {
            if (!this.userInfoData.customerId) {
                await this.createCustomer();
            } else {
                await this.createCard();
            }
        },
        async createCard() {
            await _createCard({
                groupName: this.$store.state.queryGroupName,
                customerId: this.userInfoData.customerId,
                card: this.creditCardInfo,
            })
                .then((result) => {
                    if (result.data.success == true) {
                        this.$Message.success(this.$t("global.success"));
                        this.$emit("reloadUserInfoData");
                        this.$store.commit("SET_CREDIT_CARD_INFO", result.data.data.source);
                        this.getCardInfoById(result.data.data.source.id);
                        this.closeModalEvent();
                    } else {
                        this.$Message.error(`${this.$t("global.error")} : ${result.data.message}`);
                        this.closeModalEvent();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // this.$Message.error(err.data.message);
                });
        },
        async deleteCreditCardInfo() {
            await _deleteCard({
                groupName: this.$store.state.queryGroupName,
                customerId: this.userInfoData.customerId,
                cardId: this.$store.getters.getUserPaymentInfo.cardId,
            })
                .then((result) => {
                    this.$Message.success(this.$t("global.success"));
                    this.$emit("reloadUserInfoData");
                })
                .catch((err) => {
                    this.$Message.error(this.$t("global.error"));
                });
        },
        async createCustomer() {
            await _createCustomer({
                groupName: this.$store.state.queryGroupName,
                email: this.$store.state.userData.email,
            })
                .then((result) => {
                    this.userInfoData.customerId = result.data.data.customer.id;
                    this.$emit("reloadUserInfoData");
                    this.createCard();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async getCardInfoById(cardId) {
            if (cardId) {
                await _getCard({
                    groupName: this.$store.state.queryGroupName,
                    customerId: this.userInfoData.customerId,
                    cardId: cardId ? cardId : this.$store.getters.getUserPaymentCardId,
                })
                    .then((result) => {
                        var cardInfo = result.data.data.source;
                        this.creditCardData.number = ` **** **** **** ${cardInfo.last4}`;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        formatCardNumber(number) {
            if (number.length < 17) {
                this.creditCardInfo.number = number.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ");
                return true;
            } else {
                return false;
            }
        },
        formatDate(date) {
            if (date !== undefined) {
                if (0 < date.toString().length < 7) {
                    this.creditCardInfo.date = date
                        .replace(/^([1-9]\/|[2-9])$/g, "0$1/")
                        .replace(/^(0[1-9]|1[0-2])$/g, "$1/")
                        .replace(/^1([3-9])$/g, "01/$1")
                        .replace(/^0\/|0+$/g, "0")
                        .replace(/[^\d|^\/]*/g, "")
                        .replace(/\/\//g, "/");
                    return true;
                } else {
                    return false;
                }
            }
        },
        addCreditCard() {
            this.isOpened = true;
            this.actionType = "add";
        },
        editCreditCard() {
            this.isOpened = true;
            this.actionType = "edit";
        },
        removeCreditCard() {
            this.$Modal.confirm({
                title: this.$t("accountInfo.creditCard.removeCardTitleText"),
                content: this.$t("accountInfo.creditCard.removeCardContentText"),
                okText: this.$t("accountInfo.creditCard.removeCardBtnText"),
                onOk: async () => {
                    //移除卡片
                    await this.deleteCreditCardInfo();
                    await this.$emit("reloadUserInfoData");
                },
                // onCancel: () => {
                //     // console.log("cancel remove credit card");
                // }
            });
        },
    },
    created() {},
    mounted() {
        this.getCardInfoById(this.$store.getters.getUserPaymentInfo.cardId);
        this.creditCardInfo = Object.assign({}, this.creditCardData);
    },
    computed: {
        modalTitle() {
            return this.actionType == "add"
                ? this.$t("accountInfo.creditCard.addCreditCardText")
                : this.$t("accountInfo.creditCard.editCreditCardText");
        },
        "creditCardInfo.date"() {
            return this.creditCardInfo.exp_month + "/" + this.creditCardInfo.exp_year;
        },
        chargeDate() {
            let addMonth = 0;
            // 當月付款日
            let paymentDate = moment().add(addMonth, "months").format("YYYY-MM-01");
            let paymentDayTime = Math.round(new Date(paymentDate + " 23:30:00") / 1000);
            // 現在時間
            let nowDayTime = Math.round(new Date() / 1000);
            // 超過當月付款日,需要延一個月
            if (nowDayTime > paymentDayTime) addMonth++;
            return moment().add(addMonth, "months").format("YYYY-MM-01");
        },
        isShowDescriptionTwoText() {
            return !this.userInfoData.subscription;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/creditCard/listItem.vue